webpackJsonp([142629428675168],{

/***/ 406:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Daub Creative :: Custom Websties and Mobile Apps"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-c49ee3640b58c80168ff.js